import { render, staticRenderFns } from "./AccuracyTable.vue?vue&type=template&id=0ed3311e&scoped=true&"
import script from "./AccuracyTable.vue?vue&type=script&lang=js&"
export * from "./AccuracyTable.vue?vue&type=script&lang=js&"
import style0 from "./AccuracyTable.vue?vue&type=style&index=0&id=0ed3311e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed3311e",
  null
  
)

export default component.exports